import { BORelativeDisease } from '../BORelativeDisease.model';
export class BOTranspRelativeDisease {
    relativeDiseases:BORelativeDisease[]=[];
    patientId:number;
}
